<template>
  <PanelDropdown
    v-model="isOpen"
    class="FilterDropdownPanel"
    side="bottom"
    align="start"
    :sideOffset="4"
    :disabled="disabled"
  >
    <template #trigger>
      <ChipFilter
        :selected="isOpen || hasSelection"
        readonly
        :disabled="disabled"
        :rightIcon="isOpen ? 'chevron-up' : 'chevron-down'"
      >
        {{ label }}
      </ChipFilter>
    </template>

    <div class="FilterDropdownPanel-content">
      <slot />

      <hr class="FilterDropdownPanel-divider">

      <div class="FilterDropdownPanel-actions">
        <ActionButton
          variant="primary"
          size="sm"
          class="FilterDropdownPanel-applyButton"
          @click="handleApply"
        >
          {{ applyLabel }}
        </ActionButton>
        <ActionButton
          variant="tertiary"
          size="sm"
          class="FilterDropdownPanel-clearButton"
          @click="handleClear"
        >
          {{ clearLabel }}
        </ActionButton>
      </div>
    </div>
  </PanelDropdown>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import PanelDropdown from '../PanelDropdown/PanelDropdown.vue';
import ActionButton from '../../atoms/ActionButton/ActionButton.vue';
import ChipFilter from '../../atoms/ChipFilter/ChipFilter.vue';
import type { FilterDropdownPanelProps } from './FilterDropdownPanel.model';

const props = defineProps<FilterDropdownPanelProps>();

const emit = defineEmits<{
  apply: [];
  clear: [];
}>();

const isOpen = defineModel<boolean>();

function handleClear() {
  emit('clear');
}
function handleApply() {
  emit('apply');
  isOpen.value = false;
}

watch(() => props.disabled, (newDisabled) => {
  if (newDisabled) {
    isOpen.value = false;
  }
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .FilterDropdownPanel {
    &-content {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-6;
      width: min-content;
    }

    &-divider {
      width: 100%;
      height: 0;
      margin: 0;
      border: none;
      border-block-start: vars.$dimensions-d-0-25 solid vars.$organisms-filter-row-divider-color;
    }

    &-actions {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-2;
    }

    &-clearButton,
    &-applyButton {
      flex: 1 0 0;
    }
  }
}
</style>
